module.exports = {
    languages: ['', 'ru','es','fr','ja','ko','pt','tr','zh','de','it','hi'],
    token: 'x-access-token',
    lng: 'lng',
    ftoken: 'f-token',
    privat: 'privat',
    user: 'user',
    area: 'area',
    areaType: {
        all: 'all',
        country: 'country',
        friends: 'friends'
    }
}